import React, { useState, ChangeEvent, DragEvent } from "react";

interface AudioDropzoneProps {
  onFileChange: (
    e: ChangeEvent<HTMLInputElement> | { target: { files: FileList } },
    requestId: string
  ) => void;
  requestId: string;
  progressMessage?: string;
}

const AudioDropzone: React.FC<AudioDropzoneProps> = ({
  onFileChange,
  requestId,
  progressMessage,
}) => {
  const [isDragging, setIsDragging] = useState<boolean>(false);

  const handleDrag = (e: DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragIn = (e: DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragOut = (e: DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const fakeEvent = {
        target: {
          files: files,
        },
      };
      onFileChange(fakeEvent, requestId);
    }
  };

  return (
    <div>
      <div
        style={{
          border: `2px dashed ${isDragging ? "#3b82f6" : "#ccc"}`,
          backgroundColor: isDragging ? "#f0f9ff" : "transparent",
          padding: "8px",
          minHeight: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.2s",
          position: "relative",
        }}
        onDragEnter={handleDragIn}
        onDragLeave={handleDragOut}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <input
          type="file"
          accept="audio/*"
          onChange={(e) => onFileChange(e, requestId)}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: "pointer",
            top: 0,
            left: 0,
          }}
        />
        <span style={{ fontSize: "14px", color: "#666" }}>
          파일을 드래그하거나 클릭하여 선택
        </span>
      </div>
    </div>
  );
};

export default AudioDropzone;
